import { Progress } from 'antd'
import Popup from 'shared/components/Popup'
import React from 'react'
import { Segment } from 'semantic-ui-react'

export function UsageLimit({ usage }) {
  const { usage_limits } = usage
  return (
    <Segment.Group>
      {usage_limits.map((usage_limit) => {
        const { feature_name, current_usage, maximum_usage } = usage_limit
        if (maximum_usage === '0') {
          return null
        }
        return (
          <Segment key={feature_name}>
            <div className="ui grid middle aligned h-20">
              <div className="ten wide column left floated">
                <b>{feature_name}</b>
              </div>
              <div className="six wide column right floated aligned">
                <ProgressBarWithLabel current_usage={current_usage} maximum_usage={maximum_usage} />
              </div>
            </div>
          </Segment>
        )
      })}
    </Segment.Group>
  )
}

const ProgressBarWithLabel = ({ current_usage, maximum_usage }) => {
  const total = (current_usage / maximum_usage) * 100
  return (
    <div className="text-right text-sm text-grey">
      {parseInt(current_usage).toLocaleString()} /{' '}
      {maximum_usage ? parseInt(maximum_usage).toLocaleString() : 'Unlimited'}
      {maximum_usage ? (
        <Popup
          basic
          tooltip={`${parseFloat(formatDecimal(total)).toLocaleString()}%`}
          size="mini"
          inverted
        >
          <Progress percent={total} status="normal" showInfo={false} />
        </Popup>
      ) : null}
    </div>
  )
}

const formatDecimal = (number) => {
  if (Number.isInteger(number)) {
    return number.toFixed(0)
  } else {
    if ((Math.round(number * 10) / 10) % 1 == 0) {
      return number.toFixed(0)
    } else {
      return number.toFixed(1)
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/organisms/UsageLimit/index.js